import {NgModule} from '@angular/core';
// import {BrowserModule} from '@angular/platform-browser';
import {FormComponent} from './components/form/form.component';
// tslint:disable-next-line:max-line-length
import {FormContainerMasterlistComponent} from './components/Panels/DesignerForm/ViewMasterlist/form-container-masterlist/form-container-masterlist.component';
import {FormPadComponent} from './components/Containers/form-pad/form-pad.component';
import {FlexLayoutModule} from '@angular/flex-layout';

import {FormPadColumnComponent} from './components/Containers/form-pad-column/form-pad-column.component';
import {TextboxComponent} from './components/Items/FormItems/textbox/textbox.component';
import {TextareaComponent} from './components/Items/FormItems/textarea/textarea.component';
import {DropdownComponent} from './components/Items/FormItems/dropdown/dropdown.component';
import {DateComponent} from './components/Items/FormItems/date/date.component';
import {SlideToogleComponent} from './components/Items/FormItems/slide-toogle/slide-toogle.component';
import {EMailComponent} from './components/Items/FormItems/email/email.component';
import {PhoneComponent} from './components/Items/FormItems/phone/phone.component';
import {TextMaskModule} from 'angular2-text-mask';
import {CurrencyComponent} from './components/Items/FormItems/currency/currency.component';
import {RadioGroupComponent} from './components/Items/FormItems/radio-group/radio-group.component';
import {CheckboxComponent} from './components/Items/FormItems/checkbox/checkbox.component';
import {FileUploadComponent} from './components/Items/FormItems/file-upload/file-upload.component';
import {DatasetComponent} from './components/Items/FormItems/dataset/dataset.component';
import {DatasetSelectComponent} from './components/Items/FormItems/dataset-select/dataset-select.component';
import {MapfieldComponent} from './components/Items/FormItems/mapfield/mapfield.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpFormDataService} from './services/services';
import {HttpClientModule} from '@angular/common/http';
import {NoosGridModule} from '@usteknoloji/noosgrid';
import {DialogDatasetSelectComponent} from './components/Dialogs/dialog-dataset-select/dialog-dataset-select.component';
import {DialogGoogleMapComponent} from './components/Dialogs/dialog-google-map/dialog-google-map.component';
import {AgmCoreModule} from '@agm/core';
import {FileManagerComponent} from './components/Dialogs/file-manager/file-manager.component';
import {FileTypeSelectComponent} from './components/Dialogs/file-manager/file-type-select/file-type-select.component';
import {HttpFormService} from './services/formServices';
import {AddFileComponent} from './components/Dialogs/file-manager/add-file/add-file.component';
import {NgxFilesizeModule} from 'ngx-filesize';
import {DialogFormErrorComponent} from './components/Dialogs/dialog-form-error/dialog-form-error.component';
import {HtmleditorComponent} from './components/Items/FormItems/htmleditor/htmleditor.component';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {FormContainerTabComponent} from './components/Panels/DesignerForm/ViewTab/form-container-tab/form-container-tab.component';
// tslint:disable-next-line:max-line-length
import {FormContainerStepperComponent} from './components/Panels/DesignerForm/ViewWizard/form-container-stepper/form-container-stepper.component';
import {FileButtonComponent} from './components/file-button/file-button.component';
import {ViewContainerMasterlistComponent} from './components/Panels/ViewForm/ViewMasterList/view-container-masterlist/view-container-masterlist.component';
import {ViewlabelComponent} from './components/Items/ViewItems/viewlabel/viewlabel.component';
import {ViewphotoComponent} from './components/Items/ViewItems/viewphoto/viewphoto.component';
import {ViewfilesComponent} from './components/Items/ViewItems/viewfiles/viewfiles.component';
import {ViewinfoComponent} from './components/Items/ViewItems/viewinfo/viewinfo.component';
import {ViewContainerTabComponent} from './components/Panels/ViewForm/ViewTab/view-container-tab/view-container-tab.component';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions} from '@angular/material/form-field';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatListModule} from '@angular/material/list';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MAT_BOTTOM_SHEET_DEFAULT_OPTIONS, MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatRadioModule} from '@angular/material/radio';
import {MatBadgeModule} from '@angular/material/badge';
import {MatTabsModule} from '@angular/material/tabs';
import {MatStepperModule} from '@angular/material/stepper';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MAT_LABEL_GLOBAL_OPTIONS} from '@angular/material/core';
import {CommonModule} from '@angular/common';
import {NoosFormTypeService} from './class/NoosFormTypeService';
import {ViewAppComponent} from './components/Items/ViewItems/view-app/view-app.component';
import {FormEventService} from './services/formEventService';
import {DatasetSearchComponent} from './components/Items/FormItems/dataset-search/dataset-search.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {SurveyComponent} from './components/Items/FormItems/survey/survey.component';
import {SurveyCheckboxlistComponent} from './components/Items/FormItems/survey-checkboxlist/survey-checkboxlist.component';
import {SurveyRadioComponent} from './components/Items/FormItems/survey-radio/survey-radio.component';
import {SurveyTextareaComponent} from './components/Items/FormItems/survey-textarea/survey-textarea.component';
import {ViewSurveyComponent} from './components/Items/ViewItems/view-survey/view-survey.component';
import {ViewStepperComponent} from './components/items/ViewItems/view-stepper/view-stepper.component';
import {ViewActivityComponent} from './components/Items/ViewItems/view-activity/view-activity.component';

import {BroadcastMessageService} from '@usteknoloji/noos-brodcast-messaging';
import {BompartComponent} from './components/Items/FormItems/bompart/bompart.component';
import {BomproductfieldComponent} from './components/Items/FormItems/bomproductfield/bomproductfield.component';
import {DashboardContainerMasterlistComponent} from './components/Panels/DesignerDashboard/DashboardMasterList/dashboard-container-masterlist/dashboard-container-masterlist.component';
import {PieChartComponent} from './components/Items/DashboardItems/pie-chart/pie-chart.component';
import {BarChartModule, NumberCardModule, PieChartModule} from '@swimlane/ngx-charts';
import {HorizontalBarComponent} from './components/Items/DashboardItems/horizontal-bar/horizontal-bar.component';
import {VerticalBarComponent} from './components/Items/DashboardItems/vertical-bar/vertical-bar.component';
import {GroupedHorizontalBarComponent} from './components/Items/DashboardItems/grouped-horizontal-bar/grouped-horizontal-bar.component';
import {CardChartComponent} from './components/Items/DashboardItems/card-chart/card-chart.component';
import {CalendarViewComponent} from './components/Items/DashboardItems/calendar-view/calendar-view.component';

import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import {TaskViewComponent} from './components/Items/DashboardItems/task-view/task-view.component';
import {DragDropModule} from '@angular/cdk/drag-drop';


const appearance: MatFormFieldDefaultOptions = {
    appearance: 'outline'
};

@NgModule({
    declarations: [
        FormComponent, FormContainerMasterlistComponent, FormPadComponent, FormPadColumnComponent, TextboxComponent,
        TextareaComponent,
        DropdownComponent,
        DateComponent,
        SlideToogleComponent,
        EMailComponent,
        PhoneComponent,
        CurrencyComponent,
        RadioGroupComponent,
        CheckboxComponent,
        FileUploadComponent,
        DatasetComponent,
        DatasetSelectComponent,
        MapfieldComponent,
        DialogDatasetSelectComponent,
        DialogGoogleMapComponent,
        FileManagerComponent,
        FileTypeSelectComponent,
        AddFileComponent,
        DialogFormErrorComponent,
        HtmleditorComponent,
        FormContainerTabComponent,
        FormContainerStepperComponent,
        FileButtonComponent,
        ViewContainerMasterlistComponent,
        ViewlabelComponent,
        ViewphotoComponent,
        ViewfilesComponent,
        ViewinfoComponent,
        ViewContainerTabComponent,
        ViewAppComponent,
        DatasetSearchComponent,
        SurveyComponent,
        SurveyCheckboxlistComponent,
        SurveyRadioComponent,
        SurveyTextareaComponent,
        ViewSurveyComponent,
        ViewStepperComponent,
        ViewActivityComponent,
        BompartComponent,
        BomproductfieldComponent,
        DashboardContainerMasterlistComponent,
        PieChartComponent,
        HorizontalBarComponent,
        VerticalBarComponent,
        GroupedHorizontalBarComponent,
        CardChartComponent,
        CalendarViewComponent,
        TaskViewComponent],
    imports: [
        FlexLayoutModule, CommonModule,
        MatCardModule, MatIconModule, MatMenuModule, MatButtonModule,
        MatToolbarModule, MatCheckboxModule,
        MatListModule, MatDialogModule, MatBottomSheetModule, MatSelectModule, MatInputModule, MatPaginatorModule,
        MatProgressBarModule, MatExpansionModule, MatDatepickerModule, MatSlideToggleModule, TextMaskModule,
        MatRadioModule, FormsModule, HttpClientModule,
        NoosGridModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyCLBOG7C-jjoSXYse0sFVpPRRdhUAPu428',
            libraries: ['places']
        }),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        MatBadgeModule,
        NgxFilesizeModule,
        CKEditorModule, MatTabsModule, MatStepperModule, MatProgressSpinnerModule, MatAutocompleteModule, ReactiveFormsModule,
        PieChartModule, BarChartModule, NumberCardModule, DragDropModule
    ],
    entryComponents: [
        FormComponent,
        FormContainerMasterlistComponent,
        FormPadComponent,
        FormPadColumnComponent,
        TextboxComponent,
        TextareaComponent,
        DropdownComponent,
        DateComponent,
        SlideToogleComponent,
        EMailComponent,
        PhoneComponent,
        CurrencyComponent,
        RadioGroupComponent,
        CheckboxComponent,
        FileUploadComponent,
        DatasetComponent,
        DatasetSelectComponent,
        MapfieldComponent,
        DialogDatasetSelectComponent,
        DialogGoogleMapComponent,
        FileManagerComponent, FileTypeSelectComponent, AddFileComponent, DialogFormErrorComponent, HtmleditorComponent,
        FormContainerTabComponent, FormContainerStepperComponent, FileButtonComponent, ViewContainerMasterlistComponent,
        ViewlabelComponent, ViewphotoComponent, ViewfilesComponent, ViewinfoComponent, ViewContainerTabComponent,
        ViewAppComponent, DatasetSearchComponent, SurveyComponent, SurveyCheckboxlistComponent, SurveyRadioComponent,
        SurveyTextareaComponent, ViewSurveyComponent, ViewStepperComponent, ViewActivityComponent, BompartComponent,
        BomproductfieldComponent,
        DashboardContainerMasterlistComponent,
        PieChartComponent,
        HorizontalBarComponent,
        VerticalBarComponent,
        GroupedHorizontalBarComponent,
        CardChartComponent,
        CalendarViewComponent, TaskViewComponent],
    providers: [{provide: MatDialogRef, useValue: {}},
        {
            provide: MAT_DIALOG_DATA, useValue: []
        },
        {
            provide: MAT_LABEL_GLOBAL_OPTIONS, useValue: {float: 'always'}
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: appearance
        },
        {provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS, useValue: {hasBackdrop: false}},
        // {provide: LAZY_MAPS_API_CONFIG, useClass: GoogleMapsConfig},
        HttpFormDataService,
        HttpFormService,
        NoosFormTypeService,
        FormEventService,
        BroadcastMessageService

    ],
    exports: [FormComponent, FileButtonComponent],
})
export class NoosFormModule {
}

/*

@Injectable()
class GoogleMapsConfig {
  apiKey: string;
...
  constructor() {
    apiKey = getMyApiKeyFromSomewhere()
...
  }
}
 */
